import RoleAndPermission from "../../helper/RoleAndPermission";

export default function useCheckAuthPermissions() {
    const dispatchN = (permissionKeySlug) => {
        return RoleAndPermission.checkGivenPermissionOnLoadedByPermission(permissionKeySlug)
    };
    return [dispatchN];
}
